const GRACE_DAYS = 30;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

function parseYmdAsUtcDate(dateStr) {
  if (!dateStr || typeof dateStr !== 'string') return null;
  // API format: YYYY-MM-DD
  const ms = Date.parse(`${dateStr}T00:00:00Z`);
  if (Number.isNaN(ms)) return null;
  return new Date(ms);
}

function diffDaysUtc(fromDate, toDate) {
  const fromUtc = Date.UTC(fromDate.getUTCFullYear(), fromDate.getUTCMonth(), fromDate.getUTCDate());
  const toUtc = Date.UTC(toDate.getUTCFullYear(), toDate.getUTCMonth(), toDate.getUTCDate());
  return Math.floor((toUtc - fromUtc) / MS_PER_DAY);
}

export function getSubscriptionAccess(user, now = new Date()) {
  const limits = user?.limits ?? user ?? {};
  const expiryStatus = limits?.inspection_expiry_status ?? user?.inspection_expiry_status;
  const expiryDateStr = limits?.inspection_expiry_date ?? user?.inspection_expiry_date;
  const expiryDate = parseYmdAsUtcDate(expiryDateStr);

  if (expiryStatus !== 'expired') {
    return {
      phase: 'active',
      expiryStatus,
      expiryDateStr,
      expiryDate,
      daysSinceExpiry: null,
      graceDays: GRACE_DAYS,
      canCreateInspection: true,
      canViewReports: true,
      mustContactAdmin: false
    };
  }

  // If we cannot parse the expiry date, be conservative: block creation, but don't hard-lock the account.
  if (!expiryDate) {
    return {
      phase: 'grace',
      expiryStatus,
      expiryDateStr,
      expiryDate: null,
      daysSinceExpiry: null,
      graceDays: GRACE_DAYS,
      canCreateInspection: false,
      canViewReports: true,
      mustContactAdmin: false
    };
  }

  const daysSinceExpiry = diffDaysUtc(expiryDate, now);

  // If expiry is in the future for some reason, treat as active.
  if (daysSinceExpiry < 0) {
    return {
      phase: 'active',
      expiryStatus,
      expiryDateStr,
      expiryDate,
      daysSinceExpiry,
      graceDays: GRACE_DAYS,
      canCreateInspection: true,
      canViewReports: true,
      mustContactAdmin: false
    };
  }

  if (daysSinceExpiry <= GRACE_DAYS) {
    return {
      phase: 'grace',
      expiryStatus,
      expiryDateStr,
      expiryDate,
      daysSinceExpiry,
      graceDays: GRACE_DAYS,
      canCreateInspection: false,
      canViewReports: true,
      mustContactAdmin: false
    };
  }

  return {
    phase: 'blocked',
    expiryStatus,
    expiryDateStr,
    expiryDate,
    daysSinceExpiry,
    graceDays: GRACE_DAYS,
    canCreateInspection: false,
    canViewReports: false,
    mustContactAdmin: true
  };
}

export function formatGraceEndDate(expiryDateStr) {
  const expiryDate = parseYmdAsUtcDate(expiryDateStr);
  if (!expiryDate) return null;
  const graceEnd = new Date(expiryDate.getTime() + GRACE_DAYS * MS_PER_DAY);
  return graceEnd.toISOString().slice(0, 10);
}

